import { Box, Icon, Spinner, Tooltip } from '@dixa/lib-shared-habla';

import { getLastEndUserMessage } from 'components/conversation/selectors';
import { useFeatureFlag } from 'utils/featureFlagging/useFeatureFlag';
import { useAppSelector } from 'utils/redux/useAppSelector';

import { elevioSelectors } from '../../elevio.reducer/selectors';

import { useSmartReplyResponse } from './useSmartReplyResponse';

export function SmartConversationReplyButton({
  articleBody,
}: {
  articleBody: string;
}): JSX.Element {
  const conversationContent = useAppSelector(getLastEndUserMessage) || '';

  const conversationId = useAppSelector(elevioSelectors.conversation.id);
  const articleId = useAppSelector(elevioSelectors.articleId);
  const { smartReplyNewApi: smartReplyApiV2Enabled } = useFeatureFlag([
    'smart-reply-new-api',
  ]);
  const {
    getSmartReplyResponse,
    response: { loading },
  } = useSmartReplyResponse({
    smartReplyApiV2Enabled,
    articleBody,
    articleId,
    conversationContent,
    conversationId,
  });

  if (loading) return <Spinner size={16} />;

  const tooltipContent = 'Smart Conversation Reply';

  return (
    <Tooltip content={tooltipContent} dark placement="top">
      <Box height="16px" style={{ cursor: 'pointer' }}>
        <Icon onClick={getSmartReplyResponse} name="ai" size={16} />
      </Box>
    </Tooltip>
  );
}
